/**
 * Steam Replicated Store - Theme JavaScript
 * Handles mega menus, backdrop overlays, genre toggles, and autocomplete search suggestions.
 */
document.addEventListener('DOMContentLoaded', () => {
  initMegaMenus();
  initGenreToggles();
  initSearchAutocomplete();
});

/**
 * 1. Mega Menu Popovers & Backdrop Overlays
 */
function initMegaMenus() {
  const triggers = document.querySelectorAll('.steam-dropdown-trigger');
  const popovers = document.querySelectorAll('.oeCR-_-EhS8CaxEaFAqDZ');
  const backdrop = document.getElementById('steam-backdrop');
  const menuContainer = document.getElementById('steam-menu-container');

  let activePopover = null;
  let activeTrigger = null;
  let closeTimeout = null;

  function showMenu(trigger, popover) {
    clearTimeout(closeTimeout);

    // If another menu is active, hide it instantly
    if (activePopover && activePopover !== popover) {
      activePopover.classList.remove('active');
      if (activeTrigger) {
        activeTrigger.classList.remove('_2IyR9WyPwYb15ILBjPvLR9');
        activeTrigger.setAttribute('aria-expanded', 'false');
      }
    }

    activePopover = popover;
    activeTrigger = trigger;

    // Show active states
    trigger.classList.add('_2IyR9WyPwYb15ILBjPvLR9');
    trigger.setAttribute('aria-expanded', 'true');
    popover.classList.add('active');

    // Enable backdrop dimmer
    if (menuContainer) {
      menuContainer.classList.add('_1TqaEZH4pd8k4LJDCTVmBo');
    }
    if (backdrop) {
      backdrop.classList.add('_2IyR9WyPwYb15ILBjPvLR9');
      backdrop.style.display = 'block';
    }
  }

  function hideMenu() {
    clearTimeout(closeTimeout);
    closeTimeout = setTimeout(() => {
      if (activePopover) {
        activePopover.classList.remove('active');
      }
      if (activeTrigger) {
        activeTrigger.classList.remove('_2IyR9WyPwYb15ILBjPvLR9');
        activeTrigger.setAttribute('aria-expanded', 'false');
      }
      activePopover = null;
      activeTrigger = null;

      // Hide backdrop dimmer
      if (menuContainer) {
        menuContainer.classList.remove('_1TqaEZH4pd8k4LJDCTVmBo');
      }
      if (backdrop) {
        backdrop.classList.remove('_2IyR9WyPwYb15ILBjPvLR9');
        backdrop.style.display = 'none';
      }
    }, 150); // Grace period for moving between trigger and popover
  }

  // Bind trigger hovers and keyboard focus
  triggers.forEach(trigger => {
    const targetId = trigger.getAttribute('data-target');
    const popover = document.getElementById(targetId);
    if (!popover) return;

    trigger.addEventListener('mouseenter', () => showMenu(trigger, popover));
    trigger.addEventListener('mouseleave', hideMenu);
    trigger.addEventListener('focus', () => showMenu(trigger, popover));
    trigger.addEventListener('blur', hideMenu);
  });

  // Bind popover hovers to cancel hide action
  popovers.forEach(popover => {
    popover.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    popover.addEventListener('mouseleave', hideMenu);
  });

  // Close when clicking or hovering the backdrop overlay
  if (backdrop) {
    backdrop.addEventListener('mouseenter', hideMenu);
    backdrop.addEventListener('click', hideMenu);
  }
}

/**
 * 2. Collapsible Genres & Themes Columns Grid Toggle
 */
function initGenreToggles() {
  const genresToggle = document.getElementById('genres-expanded-toggle');
  if (!genresToggle) return;

  genresToggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isExpanded = genresToggle.getAttribute('aria-expanded') === 'true';
    const collapsibles = document.querySelectorAll('.steam-genres-collapsible');
    const toggleText = document.getElementById('genres-toggle-text');
    const toggleIcon = document.getElementById('genres-toggle-icon');

    if (isExpanded) {
      // Collapse elements
      collapsibles.forEach(el => {
        el.style.display = 'none';
      });
      if (toggleText) toggleText.textContent = 'Expand';
      if (toggleIcon) toggleIcon.style.transform = 'none';
      genresToggle.setAttribute('aria-expanded', 'false');
    } else {
      // Expand elements
      collapsibles.forEach(el => {
        el.style.display = 'flex';
      });
      if (toggleText) toggleText.textContent = 'Collapse';
      if (toggleIcon) toggleIcon.style.transform = 'rotate(180deg)';
      genresToggle.setAttribute('aria-expanded', 'true');
    }
  });
}

/**
 * 3. Search Bar Autocomplete Dropdown
 */
function initSearchAutocomplete() {
  const searchInput = document.getElementById('steam-search-input');
  const suggestionsDropdown = document.getElementById('search-suggestions-dropdown');
  const popularSearches = document.getElementById('popular-searches-box');
  const dynamicResults = document.getElementById('dynamic-results-box');
  const dynamicList = document.getElementById('dynamic-results-list');

  if (!searchInput || !suggestionsDropdown) return;

  // Fetch and display live results from Shopify predictive search
  function handleSearchInput() {
    const query = searchInput.value.trim().toLowerCase();

    if (!query) {
      if (popularSearches) popularSearches.style.display = 'block';
      if (dynamicResults) dynamicResults.style.display = 'none';
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=3`)
      .then(res => res.json())
      .then(data => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products.map(p => ({
          title: p.title,
          url: p.url,
          image: p.featured_image ? p.featured_image.url : '',
          priceHtml: getPriceHtmlForShopify(p)
        })));
      })
      .catch(() => {
        if (dynamicResults) dynamicResults.style.display = 'none';
      });
  }

  function getPriceHtmlForShopify(shopifyProduct) {
    const price = parseFloat(shopifyProduct.price);
    const compareAt = parseFloat(shopifyProduct.compare_at_price_max || shopifyProduct.compare_at_price || '0');
    const isDiscounted = compareAt > price;

    if (price === 0) {
      return `
        <div class="hWF8eniTajf4-mfZvbK3F _3nY5xfLgHtFfAZehN8EnZf _3qZOpVQJRvlFkWQKldRKPD">
          <div class="_2faI25vznC0tWNttks8OaJ">
            <div class="_2L23Sk2CNSFCplu_7mMmQx">Free</div>
          </div>
        </div>
      `;
    }

    if (isDiscounted) {
      const discountPct = Math.round(((compareAt - price) / compareAt) * 100);
      return `
        <div class="hWF8eniTajf4-mfZvbK3F _3nY5xfLgHtFfAZehN8EnZf _3qZOpVQJRvlFkWQKldRKPD">
          <div class="_2lQxRlo1DQ1PN08TYTil2L">
            <div class="_3cdhtxJwOkHYnEljY7P-vL">-${discountPct}%</div>
          </div>
          <div class="_2faI25vznC0tWNttks8OaJ _1gp3t-2iXZJ_KLMSNHXImo">
            <div class="_1xgg-R84IHS6h5_x6ZycXi">$${compareAt.toFixed(2)}</div>
            <div class="_2L23Sk2CNSFCplu_7mMmQx">$${price.toFixed(2)}</div>
          </div>
        </div>
      `;
    }

    return `
      <div class="hWF8eniTajf4-mfZvbK3F _3nY5xfLgHtFfAZehN8EnZf _3qZOpVQJRvlFkWQKldRKPD">
        <div class="_2faI25vznC0tWNttks8OaJ">
          <div class="_2L23Sk2CNSFCplu_7mMmQx">$${price.toFixed(2)}</div>
        </div>
      </div>
    `;
  }

  function renderResults(results) {
    if (!dynamicList) return;
    dynamicList.innerHTML = '';

    if (results.length === 0) {
      dynamicList.innerHTML = `
        <div style="padding: 12px; color: #8b929a; font-size: 13px; text-align: center;">
          No matching products found.
        </div>
      `;
    } else {
      results.forEach(product => {
        const item = document.createElement('a');
        item.className = '_3Z1skIYVoqLbYiP2wy46Ce Focusable';
        item.href = product.url;
        item.innerHTML = `
          <div class="_2qsM52VkK9BR1Vi0HBOrtY">
            ${product.image ? `<img src="${product.image}" alt="${product.title}">` : ''}
          </div>
          <div class="_1D5FETA8rX0cTIhaC9W2wD">
            <div class="_2c8KHMFOeIi4TVcVN6qeIi">${product.title}</div>
            <div class="KG1rpRyNTy_2__H8GV8__">
              ${product.priceHtml}
            </div>
          </div>
        `;
        dynamicList.appendChild(item);
      });
    }

    if (popularSearches) popularSearches.style.display = 'none';
    if (dynamicResults) dynamicResults.style.display = 'block';
  }

  // Display suggestions panel on focus
  searchInput.addEventListener('focus', () => {
    suggestionsDropdown.style.display = 'block';
    searchInput.setAttribute('aria-expanded', 'true');
    handleSearchInput();
  });

  // Handle keyboard inputs
  searchInput.addEventListener('input', handleSearchInput);

  // Close autocomplete on click outside
  document.addEventListener('click', (e) => {
    if (!searchInput.contains(e.target) && !suggestionsDropdown.contains(e.target)) {
      suggestionsDropdown.style.display = 'none';
      searchInput.setAttribute('aria-expanded', 'false');
    }
  });
}
